// extracted by mini-css-extract-plugin
export default {"root":"roles_header___root___f534e143","scrollWrapper":"roles_header___scrollWrapper___e1737d2c","headersRow":"roles_header___headersRow___b4eb1a1e"};